import axiosInstance from "./axiosInstance";

// Get all topics
export const fetchTopics = async () => {
    const response = await axiosInstance.get("/topic/getall");
    return response.data;
};

// Create a new topic
export const createTopic = async (data) => {
    const response = await axiosInstance.post("/topic", data);
    return response.data;
};

// Update a topic
export const updateTopic = async ({ id, data }) => { 
    const response = await axiosInstance.put(`/topic/${id}`, data);
    return response.data;
};

// Delete a topic
export const deleteTopic = async (data) => {
    await axiosInstance.delete(`/topic`, {
        params: data
    });
};
